const NOT_TYPE: { [key: string]: string } = {
  default: 'Der eingegebene Wert ist ungültig. Bitte ändern Sie Ihre Eingabe.',
  number: 'In diesem Feld sind nur Zahlen erlaubt. Bitte ändern Sie Ihren Eintrag.'
}

const mixed = {
  default: '${path} ist ungültig',
  required: 'Diese Eingabe ist Pflicht.',
  oneOf: '${path} muss einem der folgenden Werte entsprechen: ${values}',
  notOneOf: '${path} darf keinem der folgenden Werte entsprechen: ${values}',
  notType: ({ type }: { type: string }) => {
    return NOT_TYPE[type] || NOT_TYPE.default
  },
  defined: '${path} muss definiert sein'
}

const string = {
  length: '${path} muss genau ${length} Zeichen lang sein',
  min: '${path} muss mindestens ${min} Zeichen lang sein',
  max: '${path} darf höchstens ${max} Zeichen lang sein',
  matches: '${path} muss wie folgt aussehen: "${regex}"',
  email: '${path} muss eine gültige E-Mail-Adresse enthalten',
  url: '${path} muss eine gültige URL sein',
  trim: '${path} darf keine Leerzeichen am Anfang oder Ende enthalten',
  lowercase: '${path} darf nur Kleinschreibung enthalten',
  uppercase: '${path} darf nur Grossschreibung enthalten'
}

const number = {
  min: '${path} muss grösser oder gleich ${min} sein',
  max: '${path} muss kleiner oder gleich ${max} sein',
  lessThan: '${path} muss kleiner sein als ${less}',
  moreThan: '${path} muss grösser sein als ${more}',
  notEqual: '${path} darf nicht gleich sein mit "${notEqual}"',
  positive: '${path} muss eine positive Zahl sein',
  negative: '${path} muss eine negative Zahl sein',
  integer: '${path} muss eine ganze Zahl sein'
}

const date = {
  min: '${path} muss später sein als ${min}',
  max: '${path} muss früher sein als ${max}'
}

const boolean = {}

const object = {
  noUnknown: '${path}-Feld darf keine Schlüssel verwenden, die nicht im "Objekt-Shape" definiert wurden'
}

const array = {
  min: '${path}-Feld muss mindesten ${min} Einträge haben',
  max: '${path}-Feld darf höchstens ${max} Einträge haben'
}

export default {
  mixed,
  string,
  number,
  date,
  object,
  array,
  boolean
}
